import { Container, Table } from "reactstrap"
import Base from "../components/Base"

const ReturnPolicy=()=>{
    return(
        <Base>
            <Container className="text-justify">
            <h3 className="mt-3">HomeoRx Return & Refund Policy</h3>
            <p>HOMEORX RETURN POLICY, REFUND, CANCELLATION AND SHIPPING CHARGES POLICY</p>

            <h5>Table of Content</h5>
            
            <li>DEFINITION</li>
            <li>RETURN PROCESS</li>
            <li>MEDICAL TEST</li>
            <li>REFUND PROCESS</li>
            <li>ONLINE CONSULTATION</li>
            <li>SHIPPING CHARGES</li>

            <h5>DEFINITION</h5>
            <small><b>'Return' means an action of giving back the product ordered at homeorx.in portal by the consumer. The following situations may arise which may cause the action of return of product:</b></small>
            <li>Product(s) delivered do not match your order;</li>
            <li>Product(s) delivered are past or near to its expiry date (medicines with an expiry date of less than 03 months shall be considered as near expiry);</li>
            <li>Product(s) delivered were damaged in transit (do not to accept any product which has a tampered seal):</li>
            <p><b>Note: If the product that you have received is damaged, then do not accept the delivery of that product. If after opening the package you discover that the product is damaged, the same may be returned for a refund. Please note that we cannot promise a replacement for all products as it will depend on the availability of the particular product, in such cases we will offer a refund.</b></p>
            <p>In the aforesaid unlikely situations, if there is something wrong with the order, we'd be happy to assist and resolve your concern. You may raise a Return request with our customer care within 07 (Seven) days from the delivery of the product. homeorx.in reserves the right to cancel the Return request, if the customer reaches out to homeorx.in after 7 days of delivery.
Upon receiving your Return/Refund request, homeorx.in shall verify the authenticity and the nature of the request. If homeorx.in finds that the request is genuine, it will initiate the Return and Refund process. homeorx.in shall process the refund only once it has received the confirmation from the vendor concerned in respect of the contents of the product relating to that refund.
In the event of frivolous and unjustified complaints regarding the quality and content of the products, homeorx.in reserves the right to pursue necessary legal actions against you and you will be solely liable for all costs incurred by homeorx.in in this regard.</p>
            
            <h6>The returns are subject to the below conditions:-</h6>
            <li><small>Any wrong ordering of product doesn’t qualify for Return;</small></li>
            <li><small>Batch number of the product being returned should match as mentioned on the invoice;</small></li>
            <li><small><b>Return requests arising due to change in prescription do not qualify for Return;</b></small></li>
            <li><small><b>Product being returned should only be in their original manufacturer's packaging i.e. with original price tags, labels, bar-code and invoice; and</b></small></li>
            <li><small><b>Partially consumed strips or products do not qualify for Return, only fully unopened strips or products can be returned.</b></small></li>
        
        
        <p>Category of Non-Returnable Product:Certain categories of products marked as non- returnable on product page, will not qualify for the Return as per homeorx.in Return policy. The details of the non- returnable products are mentioned below:</p>
        <table>
            <thead>
            <tr>
                        <td><b>Categories</b></td>
                        <td><b>Type of Products</b></td>
                    </tr>
            </thead>
            <tbody>
                   
                <tr>
                    <td>Baby Care</td>
                    <td>Bottle Nipples, Breast Nipple Care, Breast Pumps, Diapers, Ear Syringes, Nappy, Wet Reminder, Wipes and Wipe Warmers</td>
                </tr>
                <tr>
                    <td>Food and Nutrition</td>
                    <td>Health Drinks, Health Supplements</td>
                </tr>
                <tr>
                    <td>Healthcare Devices</td>
                    <td>Glucometer Lancet/Strip, Healthcare Devices and Kits, Surgical, Health Monitors</td>
                </tr>
                <tr>
                    <td>Sexual Wellness</td>
                    <td>Condoms, Fertility Kit/Supplement, Lubricants, Pregnancy Kits</td>
                </tr>
                <tr>
                    <td>Temperature Controlled and Speciality Medicines</td>
                    <td>Vials, Injections, Vaccines, Penfills and any other Product, requiring cold storage, or medicines that fall under the category of speciality medicines.</td>
                </tr>
            </tbody>
        </table>

        <h5>RETURN PROCESS:</h5>
        <li>For Return intimation, please visit www.hoeorx.com/contact and contact with us from 8AM to 8PM, Monday to Sunday.</li>
        <li>homeorx.in customer care team will verify the claim made by the customer within 72 (seventy-two) business hours from the time of receipt of complaint.</li>
        <li>Once the claim is verified as genuine and reasonable, homeorx.in will initiate the collection of product(s) to be returned</li>
        <li>The customer will be required to pack the product(s) in original manufacturer’s packaging.</li>
        <li>Refund will be completed within 30 (thirty) days from date of reverse pick up (if required).</li>

        <h5>MEDICAL TEST:</h5>
        <small>In case of medical tests, a Refund request may be raised in the following cases:</small>
        <li><small>If the patient has suffered from Haematoma or any prick related injury;</small></li>
        <li><small>If the report has been challenged and no proper justification (i.e. reasonable clarification provided either by homeorx.in or the diagnostic centre) has been provided;</small></li>
        <li><small>If the time limit within which a report has to be provided to the patient is breached by 72 (seventy-two) hours and no proper justification (i.e reasonable clarification provided either by www.homeorx.in or the diagnostic centre) has been provided.</small></li>
        
        <h5>REFUND PROCESS:</h5>
        <small>In all the above cases, if the claim is found to be valid, Refund will be made as mentioned below:</small>
        <li><small>Order placed through online wallet will be credited to the wallet; and</small></li>
        <li><small>Order placed through cash on delivery will be refunded through fund transfer to customer bank account.</small></li>

        <h5>ONLINE CONSULTATION:</h5>
        <small><b>In case of online consultation, a customer will be eligible to raise a request for Refund only in case the consultation query is not replied within specified timeline.

The customer is required to raise the Refund request with homeorx.in customer care within 72 (seventy-two) hours from the time of submission of query or receiving of response. The request for the Refund will be validated by homeorx.in customer care team.

In case of valid Refund, the same will be done by crediting the bank account of the customer. Refund process shall be completed within 30 (thirty) days from the date of submission of the request for Refund.</b></small>
        
        <h5>SHIPPING CHARGES</h5>
        Estimated shipping charges are calculated as per the value of the order and can be viewed in the cart section at the time of checkout. For any further shipping related information, please write to ermaanish@gmail.com​.
        
        <h5>CANCELLATION POLICY</h5>
        <small>Customer cancellation:

The customer can cancel the order for the product till homeorx.in ship it. Orders once shipped cannot be cancelled.

The customer can cancel the order for medical test till the collection of sample.

homeorx.in cancellation:

There may be certain orders that homeorx.in partners are unable to accept and service and these may need to be cancelled. Some situations that may result in your order being cancelled include, non-availability of the product or quantities ordered by you or inaccuracies or errors in pricing information specified by our partners.

homeorx.in also reserves the right to cancel any orders that classify as ‘Bulk Order’ as determined by homeorx.in as per certain criteria. An order can be classified as ‘Bulk Order’ if it meets with the below mentioned criteria, which may not be exhaustive, viz:

i. Products ordered are not for self-consumption but for commercial resale;

ii. Multiple orders placed for same product at the same address;

iii. Bulk quantity of the same product ordered;

iv. Invalid address given in order details;

v. Any malpractice used to place the order.

No cancellation charges shall be levied for cancellation of an order in accordance with the terms of this policy.</small>
        </Container>
        </Base>
    )
}
export default ReturnPolicy